import { render, staticRenderFns } from "./MergeOrderReferenceButtonActionModal.vue?vue&type=template&id=ca940fe0&"
import script from "./MergeOrderReferenceButtonActionModal.vue?vue&type=script&lang=js&"
export * from "./MergeOrderReferenceButtonActionModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports